<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">历史反馈</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src="../../assets/img/发布.png" class="nav-img none" />
        </div>
      </div>
  
      <div class="menu-block">
        <div class="menu-item ub ub-pc ub-ac2">
          <span>时间</span>
          <span>反馈内容</span>
          <span>状态</span>
          <span>详情</span>
        </div>
  
        <div v-for="(item,index) in  arr" :key="index">
          <div class="line"></div>
          <div class="menu-item ub ub-pc ub-ac2">
            <div class="ub ub-pc ub-ver sp">
              <span>{{ item.date }}</span>
              <span>{{ item.time }}</span>
            </div>
            <span class="sp">{{item.brife.length > 12 ? item.brife.substr(0, 11) + "..." : item.brife}}</span>
            <span class="state" v-if="item.check_state=='成功'">{{item.check_state}}</span>
            <span class="state" v-if="item.check_state=='失败'">{{item.check_state}}</span>
            <span class="state" v-if="item.check_state=='待审核'">{{item.check_state}}</span>
            <span class="details" @click="goto_complaint_details(item.id)">详情</span>
          </div>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  
  export default {
    data() {
      return {
         arr: [],
         theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_complaint_details(id){
        this.$router.push({ name: "complaint_details", params: { id: id }});
      },
      init_page() {
        var self = this;
        var uid = self.$store.state.uid;
        self.get({
          url: "/App/GetUserTsData/?uid=" + uid,
          success: function(data_serve) {
          // 处理每个数据对象，将日期和时间分开
          data_serve.forEach(function(item) {
            if (item.dtm) {
              var dtmParts = item.dtm.split(' ');
              item.date = dtmParts[0]; 
              item.time = dtmParts[1]; 
            }
          });
            self.arr = data_serve;
          },
          error: function(err) {
          }
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background-color: #EFEFEF;
  }

  .menu-block{
      padding: 0.5rem 0.8rem;
      .menu-item {
        height: 3rem;
        .sp {
          span {
            font-size: 0.75rem;
            color: #333;
          }
        }
        .state {
          font-size: 0.75rem;
          color: #333;
        }
        .details {
          font-size: 0.75rem;
          color: #BA61FF;
        }
        span {
          font-size: 0.9rem;
          font-weight: bold;
          color: #333;
        }
      }
  }
  
  .line {
    margin-top: 0.5rem;
    border-top: 1px solid #FDFDFD;
  }

  .container-dark {
    background-color: #2f2e33;
    .menu-block {
      .menu-item {
        .sp {
          span {
            color: #888;
          }
        }
        .state {
          color: #888;
        }
        .details {
          color: #BA61FF;
        }
        span {
          color: #fdfdfd;
        }
      }
      
    }
    .line {
      border-top: 1px solid #404040;
    }
  }
  </style>